import { TL } from '@/components/design-system'
import { getWrapperClassName } from '@/components/design-system/utils'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useState } from 'react'

type Props = Readonly<{
  className: string
}>

export const FormulaireContact = (props: Props) => {
  const { t } = useTranslation()
  const [formulaire, setFormulaire] = useState({ nom: '', message: '' })

  const onChange = (champ: string, valeur: string) => {
    setFormulaire({ ...formulaire, [champ]: valeur })
  }

  const onContact = () => {
    const object = t('contact-formulaire.textes.objet')
    const message = t('contact-formulaire.textes.message')
        .replace('[MESSAGE]', formulaire.message)
        .replace('[NOM]', formulaire.nom)

    window.location.href = `mailto:${ t('contact') }?subject=${ object }&body=${ encodeURIComponent(message) }`
    setFormulaire({ nom: '', message: '' })
  }

  return (
      <div className={ getWrapperClassName(props.className, 'flex flex-col gap-6') }>
        <TL.Input
            label={ t('contact-formulaire.labels.nom')! }
            value={ formulaire.nom }
            onChange={ (value) => onChange('nom', value) }/>

        <TL.Textarea
            label={ t('contact-formulaire.labels.message')! }
            rows={ 4 }
            value={ formulaire.message }
            onChange={ (value) => onChange('message', value) }/>

        <TL.Button className="w-fit max-md:w-full" onClick={ onContact }>
          { t('contact-formulaire.actions.envoyer') }
        </TL.Button>
      </div>
  )
}

FormulaireContact.defaultProps = {
  className: ''
}
